<template>
  <v-layout>
    <v-flex xs12>
      <confirmation-header-text :text="$vuetify.lang.t('$vuetify.academic_institution')" class="ml-0"
                                icon="mdi-school"/>
      <v-card-text class="pb-0 pt-3">
        <v-layout class row>
          <v-flex md4 xs12>
            <v-autocomplete
                :items="colleges"
                :rules="[rules.required]"
                class="pr-2"
                item-text="name"
                item-value="name"
                :label="$vuetify.lang.t('$vuetify.select_academic_institution') + ' *'"
                outlined
                v-model="visa.extra.application_data.name_of_academic_institution">
            </v-autocomplete>

          </v-flex>
          <v-flex md4 xs12 v-if="visa.extra.application_data.name_of_academic_institution === 'Others'">
            <v-text-field
                :label="$vuetify.lang.t('$vuetify.name_of_academic_institution') + ' *'"
                outlined
                type="text"
                v-model="visa.extra.application_data.other_name_of_academic_institution"
                :rules="[rules.required]"
            />
          </v-flex>
          <v-flex md4 xs12 class="pl-2">
            <v-text-field
                :label="$vuetify.lang.t('$vuetify.subject_to_study') + ' *'"
                outlined
                type="text"
                v-model="visa.extra.application_data.subject"
                :rules="[rules.required]"
            />
          </v-flex>
          <v-flex md4 xs12 class="pl-2">
            <address-auto-complete
                :label="$vuetify.lang.t('$vuetify.address_of_institution') + ' *'"
                country-code="np"
                v-model="visa.extra.application_data.institute_address"
                :rules="[rules.required]"
            />
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-flex>
  </v-layout>
</template>

<script>
import AddressAutoComplete from "../../AddressAutoComplete";
import ConfirmationHeaderText from "../../ConfirmationHeaderText";
import {fetchDynamicValues} from "../../../helpers/dynamicValueHelper";

export default {
  data: () => ({
    rules: {
      required: value => !!value || "Required."
    },
    options: [
      {
        text: "Nepal",
        value: "Nepal"
      },
      {
        text: "Abroad",
        value: "Abroad"
      }
    ],
    colleges:[]
  }),
  components: {
    "address-auto-complete": AddressAutoComplete, ConfirmationHeaderText
  },
  computed: {
    visa() {
      return this.$store.state.VisaSingle.visa;
    }
  },
  mounted() {
    fetchDynamicValues('College').then((res)=>{
      this.colleges = res;
    })
  }
};
</script>

<style>
</style>
